module.exports = __webpack_public_path__ + "resources/img/zoom_map.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_map.png
// module id = 1261
// module chunks = 0